import { db } from './firebase';
import { doc, updateDoc, increment, setDoc, getDoc } from 'firebase/firestore';

export const trackSession = async () => {
    // Only track once per tab session to avoid spamming
    if (sessionStorage.getItem('sq_session_tracked')) return;

    try {
        const statsRef = doc(db, 'site_stats', 'audience');

        // 1. Detect device
        let device = 'desktop';
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            device = 'tablet';
        } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            device = 'mobile';
        }

        // 2. Detect source
        let source = 'direct';
        const urlParams = new URLSearchParams(window.location.search);
        const utmSource = urlParams.get('utm_source');
        const referrer = document.referrer;

        if (utmSource) {
            if (['facebook', 'instagram', 'twitter', 'linkedin', 'github'].includes(utmSource.toLowerCase())) {
                source = 'social';
            } else {
                source = utmSource.toLowerCase();
            }
        } else if (referrer) {
            const refUrl = new URL(referrer);
            if (refUrl.hostname.includes('google') || refUrl.hostname.includes('bing') || refUrl.hostname.includes('yahoo')) {
                source = 'organic';
            } else if (['facebook.com', 't.co', 'linkedin.com', 'instagram.com'].some(s => refUrl.hostname.includes(s))) {
                source = 'social';
            } else if (!refUrl.hostname.includes(window.location.hostname)) {
                source = 'referral';
            }
        }

        // 3. Update Firestore
        // Check if doc exists first
        const snap = await getDoc(statsRef);
        if (!snap.exists()) {
            await setDoc(statsRef, {
                devices: { desktop: 0, mobile: 0, tablet: 0 },
                sources: { direct: 0, organic: 0, social: 0, referral: 0 },
                lastResetAt: new Date()
            });
        }

        await updateDoc(statsRef, {
            [`devices.${device}`]: increment(1),
            [`sources.${source}`]: increment(1)
        });

        sessionStorage.setItem('sq_session_tracked', 'true');
    } catch (err) {
        console.warn('Analytics tracking failed:', err);
    }
};
